"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HadronCollider = exports.defaultConfig = void 0;
var Accelerator_1 = __importDefault(require("./Accelerator"));
exports.defaultConfig = {
    observe: false,
    observeConfig: {
        rootMargin: '-250px 0px',
        threshold: 0.1,
    }
};
var HadronCollider = /** @class */ (function () {
    function HadronCollider(components, config) {
        if (config === void 0) { config = {}; }
        this.components = [];
        this.loadedComponents = [];
        this.config = {};
        this.observers = new Map();
        this.on = function () {
        };
        this.fire = function () {
        };
        if (HadronCollider._instance) {
            return HadronCollider._instance;
        }
        this.components = components;
        this.config = Object.assign({}, exports.defaultConfig, config);
        this.observers = new Map();
        this.accelerator = new Accelerator_1.default();
        this.on = this.accelerator.subscribe.bind(this.accelerator);
        this.fire = this.accelerator.publish.bind(this.accelerator);
        this.fire('hadron-init', { _hadron: this, components: components, config: config });
        HadronCollider._instance = this;
    }
    /**
     * Loops through all components passed to the Hadron and loads them.
     */
    HadronCollider.prototype.loadEvents = function () {
        var _this = this;
        var load = function (component) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!document.querySelector(component.target)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.loadComponent(component)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var deferredLoad = function (component) { return __awaiter(_this, void 0, void 0, function () {
            var elements;
            var _this = this;
            return __generator(this, function (_a) {
                if (!document.querySelector(component.target)) {
                    return [2 /*return*/];
                }
                elements = document.querySelectorAll(component.target);
                elements.forEach(function (element) {
                    var observer = new IntersectionObserver(function (_a) {
                        var entry = _a[0];
                        if (entry.isIntersecting) {
                            load(component);
                            elements.forEach(observer.unobserve);
                        }
                    }, _this.config.observeConfig);
                    observer.observe(element);
                });
                return [2 /*return*/];
            });
        }); };
        if (this.config.observe) {
            this.instantComponents.forEach(function (component) { return load(component); });
            this.deferredComponents.forEach(function (component) { return deferredLoad(component); });
        }
        else {
            this.components.forEach(function (component) { return load(component); });
        }
    };
    HadronCollider.prototype.loadComponent = function (component) {
        return __awaiter(this, void 0, void 0, function () {
            var Component;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, component.file()];
                    case 1:
                        Component = new (_a.sent());
                        Component.fire('load-component');
                        this.loadedComponents.push(Component);
                        this.fire('component-loaded', { component: component, Component: Component });
                        this.fire("component-" + Component.constructor._name + "-loaded", { component: component, Component: Component });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(HadronCollider.prototype, "instantComponents", {
        get: function () {
            return this.components.filter(function (component) { return component.instant; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HadronCollider.prototype, "deferredComponents", {
        get: function () {
            return this.components.filter(function (component) { return !component.instant; });
        },
        enumerable: false,
        configurable: true
    });
    HadronCollider.getInstance = function () {
        if (HadronCollider._instance) {
            return HadronCollider._instance;
        }
        throw new Error('Hadron Collider not correctly initialized.');
    };
    return HadronCollider;
}());
exports.HadronCollider = HadronCollider;
exports.default = HadronCollider;
//# sourceMappingURL=HadronCollider.js.map